import { img12, img13 } from "../assets";

const Culture = ({cultureRef}) => {
  return (
    <div ref={cultureRef} className='w-screen h-auto bg-[white] flex items-center flex-col'>
      <div className="flex flex-col items-center">
        <div className="text-[#333333] text-[24px] sm:text-[28px] font-[700] mb-[30px] mt-[40px] flex flex-col	items-center">
          <div className="text-center">VĂN HOÁ VÀ MÔI TRƯỜNG LÀM VIỆC</div>
          <div className="w-[166px] border-b-[6px] border-[#005DD7] mt-[15px]"></div>
        </div>
      </div>
      <div className="max-w-[1156px] px-[20px] flex flex-col-reverse sm:flex-row justify-between	mb-0 lg:mb-[60px] items-center	">
        <div className="flex flex-col">
          {data1.map((item) => (
            <div className="flex flex-col mb-[30px] max-w-[638px]">
              <div className="title-cultur h-[44px] bg-[#DCEEFF] rounded-[10px] w-fit pl-[10px] pr-[10px] content-center mb-[10px]">
                {item.title}
              </div>
              <div className="text-cultur">{item.content}</div>
            </div>
          ))}
        </div>
        <img className="mb-[20px] sm:mb-0 pl-0 sm:pl-[20px] h-[342px] w-[328px] sm:h-[384px] sm:w-[430px] lg:h-[451px] lg:w-[473px]" src={img12} alt="" />
      </div>
      <div className="max-w-[1156px] px-[20px] flex  flex-col sm:flex-row justify-between	items-center mb-0 lg:mb-[60px]">
        <img className="mb-[20px] sm:mb-0 pr-0 sm:pr-[20px] h-[342px] w-[328px] sm:h-[384px] sm:w-[430px] lg:h-[451px] lg:w-[473px]" src={img13} alt="" />
        <div className="flex flex-col">
          {data2.map((item) => (
            <div className="flex flex-col mb-[30px] max-w-[638px]">
              <div className="title-cultur h-[44px] bg-[#DCEEFF] rounded-[10px] w-fit pl-[10px] pr-[10px] content-center mb-[10px]">
                {item.title}
              </div>
              <div className="text-cultur">{item.content}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Culture;

const data1 = [
  {
    title: "ĐỔI MỚI SÁNG TẠO",
    content:
      "Công ty khuyến khích nhân viên đưa ra những ý tưởng mới, cải tiến quy trình làm việc để nâng cao hiệu quả.",
  },
  {
    title: "MÔI TRƯỜNG LÀM VIỆC",
    content:
      "Chuyên nghiệp, đồng nghiệp thân thiện, giàu kinh nghiệm. Được trang bị đầy đủ các công cụ và phần mềm hỗ trợ thực chiến",
  },
  {
    title: "GIAO LƯU VĂN HOÁ",
    content:
      "Tư vấn viên được trải nghiệm đa dạng các chương trình teambuilding ban nhóm đến các chuyến du lịch trong và ngoài nước",
  },
];

const data2 = [
  {
    title: "KHÁCH HÀNG LÀ TRUNG TÂM",
    content:
      "Tất cả các hoạt động của công ty đều hướng đến việc đáp ứng nhu cầu và mang lại lợi ích tối đa cho khách hàng",
  },
  {
    title: "HỘI NGHỊ KHÁCH HÀNG",
    content:
      "Tiếp cận khách hàng đa chiều, bằng nhiều chương trình cơ chế hội nghị khác nhau. Từ hội nghị workshop trải nghiệm, kiểm tra sức khoẻ đến các hội nghị bán hàng thực tiễn.",
  },
];
